module.exports = __webpack_public_path__ + "img/empty.6c669194.svg";